import styled from "styled-components";
import { primaryColor } from "../../../../config/constants";

export const HeaderContainer = styled.header`
  width: 100%;
  height: 64px;
  display: flex;
  justify-content: center;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.15);
  background-color: #fff;
  position: relative;
`;
export const Menu = styled.nav`
  width: 100%;
  max-width: 860px;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  @media (max-width: 910px) {
    width: 85%;
    position: initial;
  }
`;
export const LanguageLogoutContainer = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
export const BtnLogout = styled.button`
  margin-left: 20px;
  padding-left: 20px;
  height: 35px;
  font-size: 14px;
  font-weight: bold;
  color: ${primaryColor};
  border: none;
  outline: none;
  border-left: 1px solid #b3b3b3;
  background: transparent;
  cursor: pointer;
`;
